export default __webpack_public_path__ + "static/media/cartSummaryBg.95309f4f.jpg";